__turbopack_context__.v({
  "className": "ypslNW_className",
  "variable": "ypslNW_variable",
});
